function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import * as React from "react";
var SvgIconCoins = function SvgIconCoins(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "currentColor"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M15 5.28169C15 6.69002 12.0899 7.83169 8.5 7.83169C4.91015 7.83169 2 6.69002 2 5.28169M15 5.28169C15 3.87336 12.0899 2.73169 8.5 2.73169C4.91015 2.73169 2 3.87336 2 5.28169M15 5.28169V17.1817C15 18.59 12.0899 19.7317 8.5 19.7317C4.91015 19.7317 2 18.59 2 17.1817V5.28169M15 9.2483C15 10.6566 12.0899 11.7983 8.5 11.7983C4.91015 11.7983 2 10.6566 2 9.2483M15 13.2122C15 14.6205 12.0899 15.7622 8.5 15.7622C4.91015 15.7622 2 14.6205 2 13.2122",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 5.25,
    fill: "#F4F5FB",
    strokeWidth: 1.5
  }));
};
export default SvgIconCoins;